"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenContext = void 0;
const react_1 = require("react");
exports.TokenContext = react_1.createContext({
    accessToken: null,
    authUrl: null,
    isIntercepting: false,
    error: undefined,
    clear: () => { },
    client: null,
    logoutUrl: null,
    clientId: null,
    accessTokenUri: null,
});
//# sourceMappingURL=TokenContext.js.map